<template>
  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a>Schedules</a></li>
      </ol>
    </div>
    <div class="sub-navbar align-items-center">
      <div class="sub-left">
        <ul class="link-list" v-if="currentPublishSchedule.length>0">
          <li v-for="item in currentPublishSchedule" :class="{'active':item.id==roster_schedule_id}">
            <a :href="'/schedule/publish/'+item.id+'/weeks'" class="text-capitalize">
              <span v-if="item.name"> {{ item.name }}</span>
              <span v-else>{{ item.start_date | moment("MMMM  D") }} ~ {{ item.end_date | moment("MMMM  D ") }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="sub-right extra">
        <ul class="right-links">
          <li class="sub-left-inrgt p-0">
            <job-roles-filter :jobTypes="jobTypes" @selectedShift="filterFunction"></job-roles-filter>
          </li>
          <li>
            <a href="javascript:void(0);" data-toggle="modal"
               data-target="#publishModel" class="btn btn-primary"><span class="ico ico-edit"></span>Edit</a>

          </li>
        </ul>
      </div>
    </div>
    <div class="main-box two-column pt-5">
      <div class="left-side">
        <div class="start-week">
          <h5>
            Scheduling Name
            <small>
              <router-link :to="'/schedule/publish/'+roster_schedule_id+'/weeks'"
                           class=" flex-shrink-0 pl-2 mr-20 text-capitalize" title="Click here">{{ schedule_name }}
              </router-link>
            </small>
          </h5>
        </div>
        <div class="week-table table-responsive-xxl mb-40 "
             v-bind:class="{ 'filter-active-cus' : filterActiveCus == true}" v-for="week in byWeekly">
          <!--{{week}}-->
          <table class="table " style="position: relative">
                  <span class="spinnerCustom">
                     <clip-loader :loading="loadingSpinMain" :size="sizeMain" :color="spinnerColor"></clip-loader>
                </span>
            <thead class="thead">
            <tr>
              <th v-for="day in weeksDatesByWeek[week]" :key="day" :data-day="day">
                <a class="btn btn-dark-gary btn-sm active" style="background: #fd4f50"
                   v-if="day===currentDate">Today,{{ day | moment(' D MMM') }}
                </a>
                <a class="btn btn-dark-gary btn-sm" v-else>{{ day | moment('ddd, D MMM') }}
                </a>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
            </tr>
            <tr>
              <td class="schedule-td" v-for="(day,keyIndex) in weeksDatesByWeek[week]" :keyIndex="day"
                  :class="day===currentDate?' activeToday':''">
                <router-link :to="'/schedule/publish/'+roster_schedule_id+'/weeks/'+weekNo[week][0]+'/date/'+day">
                  <div class="inner-td-wrp">
                    <div>
                      <div class="card-wrapper" v-for="(info,index) in newarray[week+day]" :key="index">
                        <!--                      {{index}}-->
                        <!--                      {{ employeeShiftHours[day + info.start_time + info.end_time].length }}-->
                        <time class="opacity-1"
                              :data-jobroleid="info.job_role_id"
                              v-if="employeeShiftHours[day+info.start_time+info.end_time] " datetime="2021-12-15 15:00">
                          {{
                            getRespondStartHour(employeeShiftHours, day, info)
                          }} -
                          {{ getRespondEndHour(employeeShiftHours, day, info) }}
                        </time>
                        <div v-if="employeeShiftHours[day+info.start_time+info.end_time]">
                          <div class="mini-card-wrp"
                               v-for="(item,keyInt) in  employeeShiftHours[day+info.start_time+info.end_time].shift">
                            <div class="mini-card border-gray " :data-jobroleid="item.jobRole.id"
                                 v-bind:class="[  getRespondClassMatchRole(selectedShift,item.jobRole.id ) ,
                                 getRespondClassMatchAvailable(selectedShift,'available_'+item.is_shift_available ) ,
                                 getRespondClassMatchOnDuty(selectedShift,'on_duty_1',item,day,currentDate)
                                   ]">
                              <div class="card-body">

                                                <span class="emp-designation" v-if="item.employee">
                                                  <i class="ico ico-fill-circle"
                                                     :class="item.attendance ? item.attendance.punch_in_time && item.attendance.punch_out_time==null && day===currentDate ? 'blink' : 'unBlink':''"
                                                     :style="'color:'+item.jobRole.color"
                                                     :data-color="item.jobRole.color">
                                                  </i>
                                                     {{ item.employee.name }}
                                                  <span class="pl-5 text-nowrap" style="font-size:9px"
                                                        v-if="item.attendance">
                                                    ({{
                                                      timeFormat(item.attendance.punch_in_time)
                                                    }} {{ item.attendance.punch_out_time ? ' - ' + timeFormat(item.attendance.punch_out_time) : ' - --:--' }})
                                                  </span>
                                                </span>
                                <span class="text-danger text-capitalize emp-designation font-weight-bold pt-10" v-else>
                                <i class="ico ico-fill-circle text-danger"></i> open shift

                              </span>
                                <span class="sync-icon" v-if="item.is_shift_available>0"><i
                                  class="fas fa-sync"></i></span>
                                <div class="d-flex justify-content-between">
                                <span class="total-tag-sm" v-if="item.employee">
                                  <span v-if="item.employee.employment_type == 'full-time'">
                                    {{ currencySymbol }} {{ item.emp_hourly_rate ? item.emp_hourly_rate.toFixed(2) : 0 }} / hr
                                  </span>
                                  <span class="total-tag-sm" v-else>
                                    {{ currencySymbol }} {{ item.employee.hourly_rate }} / hr
                                  </span>
                                </span>
                                <span class="total-tag-sm" v-if="item.employee">
                                  <span v-if="item.employee.employment_type == 'full-time'">
                                    {{currencyAmountFormat(hourlyPriceCalculate(item.emp_hourly_rate,item.start_time,item.end_time,item.employee.name,0,item.date))}} {{ currencySymbol }}
                                  </span>
                                  <span class="total-tag-sm" v-else>
                                    {{currencyAmountFormat(hourlyPriceCalculate(item.employee.hourly_rate,item.start_time,item.end_time,item.employee.name,0,item.date))}} {{ currencySymbol }}
                                  </span>
                                  </span>
                                </div>
                              </div>
                              <!--edit div-->
                              <div class="overlayer-btn">
                                <ul>
                                  <li>
                                    <a href="#" v-if="item.is_shift_available>0" class="over-btn"
                                       @click.stop.prevent="availableShiftAssignModal(item.id,item.employee.id,item.date,item.jobRole.id)">
                                      <i class="fas fa-sync"></i>
                                    </a>
                                    <a href="#" v-else class="over-btn"
                                       @click.stop.prevent="availableShiftModal(item.id)"
                                    ><i title="Make shift available" class="text-success ico-hand"></i></a>
                                  </li>
                                  <li>
                                    <a title="Edit" class="over-btn" data-toggle="collapse" @click=editSchedule(item.id)
                                       :href="'#shift-dropdown-edit'+index+'-'+week+day+keyInt" role="button"
                                       aria-expanded="false" aria-controls="shift-dropdown"><i
                                      class="ico-pencil"></i></a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                        </div>
                      </div>
                      <div class="shift-dropdown shiftDropdownCus">
                        <!--Total Rs 1400/hr-->
                        <div class="total-tag-lg" v-if="newarray[week+day]">
                          <span class="tag-title" v-if="totalCostByDate[week][keyIndex]>0">Total</span>
                          <span class="total-amount"
                                v-if="totalCostByDate[week][keyIndex]>0">{{
                              currencyAmountFormat(totalCostByDate[week][keyIndex])
                            }} {{ currencySymbol }}</span>
                        </div>
                      </div>
                    </div>

                  </div>
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>

    </div>
    <div class="modal fade " id="publishModel" tabindex="-1" role="dialog" aria-labelledby="publishModelLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content absence-model publishModel ">
          <div class="modal-header">
            <h5 class="modal-title">Are you sure you want to edit your schedule?
            </h5>
            <p></p>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body">
            <p>You are changing your schedule state from published back into planning. Use the planning tool to edit
              your schedule.</p>
            <h5 class="modal-title sub-heading" id="publishModelLabel">IMPORTANT: When you are editing your
              schedule:</h5>
            <ul class="publish-sch">
              <li>Your employees can still see their current shifts.</li>
              <li>You employees can’t swap shifts.</li>
              <li>Your employees can’t write messages</li>
              <li>Your employees can’t edit their attendance</li>
            </ul>
          </div>
          <div class="modal-footer">
            <a href="#" class="btn btn-outline-warning btn-sm" data-dismiss="modal"
               aria-label="Close">Cancel</a>
            <button @click="editScheduleFun" class="btn btn-outline-primary btn-sm">Edit Schedule</button>
          </div>
        </div>
      </div>
    </div>
    <!--available-->
    <div class="modal fade " id="availableShiftModel" tabindex="-1" role="dialog" aria-labelledby="publishModelLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content absence-model publishModel ">
          <div class="modal-header">
            <h5 class="modal-title">Make shift available
            </h5>
            <p></p>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body">

            <div class="simple-text">
              <p>Want to make your shift available to others? It's yours until someone accepts the shift.</p>
            </div>

          </div>
          <div class="modal-footer">
            <a href="#" class="btn btn-outline-warning btn-sm" data-dismiss="modal"
               aria-label="Close">Cancel</a>
            <button @click="makeItAvailableShiftFun" class="btn btn-outline-primary btn-sm">Yes Please. Make it
              available
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--available-->
    <div class="modal fade " id="availableShiftAssignModel" tabindex="-1" role="dialog"
         aria-labelledby="publishModelLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content absence-model publishModel ">
          <div class="modal-header">
            <h5 class="modal-title">I want to hand over the shift
            </h5>
            <p></p>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body">
            <p>You are about to hand over the shift from one employee to another. You can also remove the employee from
              the shift.</p>
            <form action="">
              <div class="form-group">
                <select name="" v-model="employee_id" id="" class="form-control text-capitalize">
                  <option value="">Select</option>
                  <option v-for="employee in jobTypesEmployees" :value="employee.employee.id" class="text-capitalize">
                    {{ employee.employee.name }}
                  </option>
                </select>
              </div>
            </form>

          </div>
          <div class="modal-footer">
            <a href="#" class="btn btn-outline-warning btn-sm" data-dismiss="modal"
               aria-label="Close">Cancel</a>
            <button @click="handOverShiftFun" class="btn btn-outline-primary btn-sm">Hand over shift</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import router from '../../router/router'
import axios from "axios";
import jobRolesFilter from "./partials/jobRolesFilter";
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';

export default {
  name: 'signup',
  components: {
    'jobRolesFilter': jobRolesFilter, ClipLoader
  },
  data() {
    return {
      sizeMain: '35px',
      spinnerColor: '#00779C',
      loadingSpinMain: false,
      currencySymbol: (this.$store.getters.getSelectedCompany.currency) ? this.$store.getters.getSelectedCompany.currency.symbol : 'Rs',
      filterActiveCus: false,
      currentPublishSchedule: [],
      weekNo: [],
      schedule_name: '',
      byWeekly: 1,
      selected: 1,
      company_id: this.$store.getters.getSelectedCompany.id,
      currentDate: moment(new Date()).format('YYYY-MM-DD'),
      startWeek: moment().weekday(1),
      endWeek: moment().weekday(7),
      // selectedDate: moment().weekday(1).format('YYYY-MM-DD') + '  ' + moment().weekday(7).format('YYYY-MM-DD'),
      selectedDate: [moment().weekday(1).format('YYYY-MM-DD'), moment().weekday(7).format('YYYY-MM-DD')],
      listProducts: '',
      date: new Date(),
      otherdate: new Date(),

      roster_schedule_id: this.$route.params.id,
      employees: [],
      employee_id: '',
      schedule: [],
      weeksDates: [],
      weeksDatesByWeek: [],
      newarray: [],
      jobTypes: [],
      jobTypesEmployees: [],
      copySchedulesByDateArray: [],
      schedule_ids: [],
      scheduleForm: {
        date: '',
        start_time: '',
        end_time: '',
        break_time: '',
        job_role_id: '',
        employee_id: '',
        company_id: this.$store.getters.getSelectedCompany.id,
        comment: '',
      },
      selectedShift: 0,
      selectedShiftLabel: 'All Shift',
      shiftNeedAssignment: 0,
      hoursAssigned: 0,
      minutesAssigned: 0,
      availableShiftHours: 0,
      availableShiftMinutes: 0,
      totalHoursPerEmp: 0,
      totalMinutesPerEmp: 0,
      totalHoursPerEmployeeList: [],

      newDateNext: '',
      newJobRoleNameForm: false,
      new_job_role_name: '',
      new_job_role_name_error: '',
      totalCostByDate: [],
      totalCost: [],
      employeeShiftHours: [],
      makeItAvalibaleShift: '',
      makeItAvalibaleShiftDate: '',


    }
  },

  created() {

    this.main();
    this.getJobType();
    this.getPublishSchedule();


  },

  methods: {
    getRespondClassMatchRole(selectedValue, itemValue) {
      return selectedValue === itemValue ? 'matchShiftClass' : 'matchShiftClassNew'
    },
    getRespondClassMatchAvailable(selectedValue, itemValue) {
      return selectedValue === itemValue ? 'matchShiftClass' : 'matchShiftClassNew'
    },
    getRespondClassMatchOnDuty(selectedValue, itemValue, item, day, currentDate) {
      return item.attendance ? item.attendance.punch_in_time && item.attendance.punch_out_time == null && day === currentDate && selectedValue === itemValue ? 'matchShiftClass' : 'matchShiftClassNew' : ''
    },

    getRespondStartHour(employeeShiftHours, day, info) {
      return employeeShiftHours[day + info.start_time + info.end_time].start_time.split(':')[0] + ":" + employeeShiftHours[day + info.start_time + info.end_time].start_time.split(':')[1];
    },
    getRespondEndHour(employeeShiftHours, day, info) {
      return employeeShiftHours[day + info.start_time + info.end_time].end_time.split(':')[0] + ":" + employeeShiftHours[day + info.start_time + info.end_time].end_time.split(':')[1];
    },

    getPublishSchedule() {
      let params = {company_id: this.company_id}
      this.$axios
        .get(this.$API_URL + 'api/dashboard/publish-schedules', {
          params: params,
          headers: this.getAuthHeader()
        })
        .then(response => {
          if(response.data){

            this.currentPublishSchedule = response.data
          }
          //console.log(this.currentPublishSchedule,'adas');
        })
        .catch(error => {
          //console.log(error);
        })
    },
    timeFormat(time) {
      return moment(time).format('HH:mm');
    },
    availableShiftAssignModal(id, empId, date, jobRoleId) {
      this.makeItAvalibaleShift = id;
      this.makeItAvalibaleShiftDate = date;
      // this.getEmployees(id,empId);
      //alert(jobRoleId);
      this.getEmployeeByJobRoleId(jobRoleId);
      $('#availableShiftAssignModel').modal('show');
    },
    handOverShiftFun() {
      axios.post(this.$handOverShiftAvailable,
        {
          id: this.makeItAvalibaleShift,
          date: this.makeItAvalibaleShiftDate,
          employee_id: this.employee_id,
          company_id: this.company_id,
        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.status == 200) {
            this.main();
            $('#availableShiftModel').modal('hide');
          }
          //Perform Success Action
        })
        .catch((error) => {
          // error.response.status Check status code
        }).finally(() => {
        //Perform action in always
      });
      $('#availableShiftAssignModel').modal('hide');

    },
    availableShiftModal(id) {
      this.makeItAvalibaleShift = id;
      $('#availableShiftModel').modal('show');
    },
    makeItAvailableShiftFun() {
      axios.post(this.$makeItShiftAvailable,
        {
          id: this.makeItAvalibaleShift,
          company_id: this.company_id,
        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.status == 200) {
            this.main();
            $('#availableShiftModel').modal('hide');
          }
          //Perform Success Action
        })
        .catch((error) => {
          // error.response.status Check status code
        }).finally(() => {
        //Perform action in always
      });

    },
    getEmployees(id, empId) {
      this.$axios({
        method: "get",
        params: {
          company_id: this.$store.getters.getSelectedCompany.id,
          filter_by: "EMPLOYEE"
        },
        url: this.$GetEmployees,
        headers: this.getAuthHeader()
      }).then(res => {
        if (res.data.status == 200) {
          this.employees = [];
          var filteredEmployees = res.data.result;
          filteredEmployees.filter(item => {
            if (item.id != empId) {
              this.employees.push(item)
            }
          });
          // this.employees =res.data.result;
        }
      });
    },
    editScheduleFun() {
      $('#publishModel').modal('hide');
      axios.post(this.$SchedulesStatusUpdate,
        {
          status: '2',
          roster_schedule_id: this.roster_schedule_id,
          company_id: this.company_id,
        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.status == 200) {
            this.$router.push({path: '/schedule/' + this.roster_schedule_id});
          }
        });

    },
    refreshJobRoles() {
      this.$root.$emit('refreshJobRoles');
    },

    hourlyPriceCalculate(hourlyRate, startTime, endTime, name, breakTime, date) {
      return this.getHourlyPriceCalculate(hourlyRate, startTime, endTime, name, breakTime, date);
    },
    //-----------------next button click -----------


    filterFunction(id, name) {
      if (id == 0 || id == '') {
        this.filterActiveCus = false;
      } else {
        this.filterActiveCus = true;
      }
      this.selectedShiftLabel = name;
      // this.selectedShift = event.target.value;
      this.selectedShift = id;
      //console.log(this.selectedShift,'selectedShift');
    },

    addShiftBtn() {
      this.scheduleForm.date = "";
      this.scheduleForm.start_time = '';
      this.scheduleForm.end_time = '';
      this.scheduleForm.break_time = '';
      this.scheduleForm.job_role_id = '';
      this.scheduleForm.employee_id = '';
      this.scheduleForm.company_id = '';
      this.scheduleForm.comment = '';

    },
    editSchedule(id) {
      axios.get(this.$Schedule + '/' + id + '/edit', {
        headers: this.getAuthHeader(),
      })
        .then(res => {
          if (res.data.status == 200) {
            this.scheduleForm = res.data.result;
            this.getEmployeeByJobRoleId(this.scheduleForm.job_role_id);
          }
        });
    },

    deleteSchedule(id) {
      if (confirm("Do you really want to delete?")) {
        axios.delete(this.$Schedules + '/' + id,
          {headers: this.getAuthHeader()})
          .then((res) => {
            if (res.status == 200) {
              this.main();
            }
          });
      }
    },
    updateSchedule(id) {
      axios.put(this.$Schedules + '/' + id,
        {
          date: this.scheduleForm.date,
          start_time: this.scheduleForm.start_time,
          end_time: this.scheduleForm.end_time,
          break_time: this.scheduleForm.break_time,
          job_role_id: this.scheduleForm.job_role_id,
          employee_id: this.scheduleForm.employee_id,
          company_id: this.company_id,
          comment: this.scheduleForm.comment,
        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.status == 200) {
            this.main();
          }
        });
    },


    calculateWeeksDays(date) {
      // let curr = new Date(date);
      var days = moment(this.endWeek).diff(moment(this.startWeek), 'days');
      var difWeek = moment(this.endWeek).diff(moment(this.startWeek), 'week');
      this.byWeekly = difWeek + 1;
      this.newDateNext = date;
      for (let i = 1; i <= difWeek + 1; i++) {
        let curr = new Date(this.newDateNext);
        var newDate = moment(curr).add(-1, 'd').format('YYYY-MM-DD');
        newDate = moment(newDate);
        this.weeksDatesByWeek[i] = Array(7).fill().map(
          () => newDate.add(1, 'd').format('YYYY-MM-DD')
        );
        this.newDateNext = moment(newDate).add(1, 'd');
        this.otherdate = moment(curr).add(6, 'd').format('YYYY-MM-DD');
      }
      this.getByWeekly(difWeek + 1);
      //  console.log( this.weeksDatesByWeek);
    },
    getByWeekly(length) {
      this.byWeekly = length;
    },
    getJobType() {
      axios
        .get(this.$GetJobRulesType, {
          headers: this.getAuthHeader(),
          params: {
            company_id: this.company_id,
          }
        })
        .then(res => {
          if (res.data.status == 200) {
            this.allJobTypes = res.data.result;
            this.jobTypes = this.allJobTypes;
          }
        });
    },
    getEmployeeByJobRoleChange(event) {
      if (event.target.value == 'new') {
        this.newJobRoleNameForm = true;
        return 1;
      } else {
        this.jobTypesEmployees = [];
        axios.get(this.$GetEmployeesByJobRolesType, {
          headers: this.getAuthHeader(),
          params: {
            job_role_id: event.target.value,
            company_id: this.company_id,
          }
        })
          .then(res => {
            if (res.data.status == 200) {
              this.jobTypesEmployees = res.data.result;
            }
          });

      }
    },

    getEmployeeByJobRoleId(id) {
      axios.get(this.$GetEmployeesByJobRolesType, {
        headers: this.getAuthHeader(),
        params: {
          job_role_id: id,
          company_id: this.company_id,
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.jobTypesEmployees = res.data.result;
          }
        });
    },
    shiftSaveFunc(date) {
      this.scheduleForm.date = date;
      this.submitForm();

      this.scheduleForm = {};
    },


    submitForm() {
      if (this.scheduleForm.date == '') {
        return 1;
      }
      axios.post(this.$Schedules,
        {
          start_date: moment(this.startWeek).format('YYYY-MM-DD'),
          end_date: moment(this.endWeek).format('YYYY-MM-DD'),
          roster_schedule_id: this.roster_schedule_id,
          date: this.scheduleForm.date,
          start_time: this.scheduleForm.start_time,
          end_time: this.scheduleForm.end_time,
          break_time: this.scheduleForm.break_time,
          job_role_id: this.scheduleForm.job_role_id,
          employee_id: this.scheduleForm.employee_id,
          company_id: this.company_id,
          comment: this.scheduleForm.comment,
        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.status == 200) {
            this.roster_schedule_id = res.data.result.roster_schedule_id;

            this.main();
            //return;
          }
        });
    },

    main() {
      this.loadingSpinMain = true;
      let params = {
        company_id: this.company_id,
        roster_schedule_id: this.roster_schedule_id,
        start_date: moment(this.startWeek).format('YYYY-MM-DD'),
        end_date: moment(this.endWeek).format('YYYY-MM-DD')
      };
      if (this.$route.params.id == undefined) {
        this.calculateWeeksDays(this.startWeek);
      }
      this.$axios.get(this.$Schedule, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(response => {
        this.loadingSpinMain = false;
        if (response.status == 200 && response.data.result != null) {
          //console.log(response.data, 'response.data.result');
          this.schedule_name = (response.data.result) ? response.data.result.name : '';
          this.weekStartDate = response.data.result.start_date;
          this.weekEndDate = response.data.result.end_date;
          this.startWeek = response.data.result.start_date;
          this.endWeek = response.data.result.end_date;
          this.selectedDate = [moment(this.weekStartDate).format('YYYY-MM-DD'), moment(this.weekEndDate).format('YYYY-MM-DD')];
          this.calculateWeeksDays(this.weekStartDate);
          this.employeeShiftHours = response.data.result.employeeShiftHours;
          this.schedule = response.data.result.schedules;
          var difWeek = moment(response.data.result.end_date).diff(moment(response.data.result.start_date), 'week');
          this.byWeekly = difWeek + 1;
          this.getByWeekly(difWeek + 1);
          var totalCost = 0;
          for (let week = 1; week <= difWeek + 1; week++) {
            // this.byWeekly.forEach(week => {
            this.totalCostByDate[week] = [];
            this.weekNo[week] = [];
            this.weeksDatesByWeek[week].forEach((wd, key) => {
              if (key == 0) {
                this.weekNo[week].push(moment(wd).week());
              }
              var employeeCost = 0;
              // this.weeksDatesByWeek[week].push(wd);
              this.newarray[week + wd] = [];

              this.schedule.forEach((sc, key) => {
                if (wd == sc.date) {
                  if (sc.mark_deleted == 0) {
                    var startTime = moment(sc.start_time, "HH:mm");
                    var endTime = moment(sc.end_time, "HH:mm");
                    var duration = moment.duration(endTime.diff(startTime));
                    var hours = parseInt(duration.asHours());
                    var minutes = parseInt(duration.asMinutes()) - hours * 60;
                    if (sc.employee == null) {
                      this.shiftNeedAssignment = this.shiftNeedAssignment + 1;
                      this.availableShiftHours = this.availableShiftHours + hours;
                      this.availableShiftMinutes = this.availableShiftMinutes + minutes;
                    } else {
                      this.hoursAssigned = this.hoursAssigned + hours;
                      this.minutesAssigned = this.minutesAssigned + minutes;
                    }
                    this.totalHoursPerEmp = this.totalHoursPerEmp + hours;
                    this.totalMinutesPerEmp = this.totalMinutesPerEmp + minutes;

                    //console.log(res,'res');
                    this.schedule_ids.push(sc.id);
                    //------------- calculate total date cost-------------------
                    if (sc.employee) {
                      if(sc.employee.employment_type =='full-time')
                      {
                        employeeCost = employeeCost + this.hourlyPriceCalculate(sc.emp_hourly_rate, sc.start_time, sc.end_time, sc.employee.name, 0, sc.date);
                      }else{
                        employeeCost = employeeCost + this.hourlyPriceCalculate(sc.employee.hourly_rate, sc.start_time, sc.end_time, sc.employee.name, 0, sc.date);
                      }
                    }
                    const maxWorkdaysInRow = this.newarray[week + wd].findIndex(el => el.start_time == sc.start_time & el.end_time == sc.end_time);
                    if (maxWorkdaysInRow < 0) {
                      this.newarray[week + wd].push(sc);
                    }
                  }
                }
              });

              totalCost = totalCost + employeeCost;
              this.totalCostByDate[week].push(employeeCost);
            });
          }
          this.totalCost = totalCost;
        }

      });

    },


    currencyAmountFormat(value) {
      return this.currencyFormatter(value);
    }

  }
}
</script>

<style>
.table td.schedule-td:hover .cardWrapperCus {
  display: block;
  background: rgba(0, 119, 156, 0.2);
  border-radius: 10px;
}

.card-wrapper.cardWrapperCus {
  display: none;
}

.btn {
  position: reltive;
}

.icoCopyByDate {
  font-size: 15px;
  margin-left: 10px;
  color: black;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0;
  transition: all .25s linear;
}

.btn:hover .icoCopyByDate {
  display: inline-block;
  vertical-align: middle;
  opacity: 1;
}

.inner-td-wrp {
  min-height: 200px;

}

.schedule-td:hover .inner-td-wrp .copy-days {
  display: block;
}

.inner-td-wrp .copy-days {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 2;
  width: 100%;
  display: none


}

.week-table .inner-td-wrp .copy-days:before {
  top: 0;
  bottom: 0;
  width: 100%;
  position: absolute;
  background: #dddcdc;
}

.arrow-r .arrow-icon::after {
  right: 41px !important;

}


.right-side .card {
  overflow: visible !important;
}

/*  .week-table{
    overflow-x: auto ;
    overflow-y: hidden;
  }
  .week-table table td{
    min-width: 165px;
  }*/

.job-roll {
  position: relative;
}

.job-roll .nav-selectdrop {
  position: static;
}

.job-roll .overlayer-input {
  visibility: visible;
  opacity: 1;
}

.overlayer-input {
  visibility: hidden;
  opacity: 0;
  display: flex;
  background: #fff;
  position: absolute;
  left: 0;
  top: 28px;

  right: 0;
  z-index: 1;
}

.overlayer-input input {
  width: 100%;
  margin-right: 10px;

}

.overlayer-input .btn-cancel, .btn-save {
  width: auto !important;
  margin: 0 5px;
}

.total-tag-sm {
  font-size: 10px;
  line-height: 14px;
  color: #989898;
  display: block;
  margin-bottom: 2px;
}

.week-table .mini-card .card-body h4 {

  line-height: 18px !important;
}

.shiftDropdownCus {
  /* background: #f6f6f6; */
  border-radius: 8px;

}


/*.col-red{
  color: ;
}*/

.total-hours-per-emp-cus {
  max-height: 360px;
  margin: 0 -20px;
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;
  background-clip: padding-box;

}

.spinnerCustom .v-spinner {
  /*display: block;*/
  position: absolute;
  margin: 0 auto;
  width: 100%;
  z-index: 1111111;
  top: 50%;
}
</style>
